import { Map } from 'immutable';
import type { AnyAction } from 'redux';

import { ADD, ADD_MULTIPLE, UPDATE, REMOVE } from './constants';
import type Cause from './model';

export type CauseState = Map<string, Cause>;

const initialState: CauseState = Map();

export default (state = initialState, action: AnyAction): CauseState => {
  switch (action.type) {
    case ADD:
      return state.set(action.cause.id, action.cause);

    case ADD_MULTIPLE:
      return state.merge(action.causes);

    case UPDATE:
      return state.set(action.cause.id, action.cause);

    case REMOVE:
      return state.delete(action.id);

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
